import { FormField } from "@/components/elements/FormField/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Textarea } from "@/components/elements/Textarea";
import { TLearnerNotesForm } from "@/features/learning-progress/schema/useLearnerNotesSchema";
import { black, divider } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

export const EncouragementMessageEditSection: FC = () => {
  const { control } = useFormContext<TLearnerNotesForm>();

  return (
    <InnerBox
      p={3}
      showDivider={false}
      borderColor={divider.high}
      bordered
      title="外国人本人宛"
    >
      <Stack mt={1} gap={1}>
        <Typography variant="cap12" color={black[70]}>
          ご本人への応援メッセージ
        </Typography>
        <FormField control={control} name="encouragementMsg" noLabel>
          <Textarea placeholder="入力してください" minRows={4} maxRows={8} />
        </FormField>
      </Stack>
    </InnerBox>
  );
};
